import http from '../HttpWrapper'

export type JobSeekerSignupReq = {
    name: string
    email: string
    phone?: string
    linkedinUrl: string
    acceptedTerms: boolean
    source?: string
    screeningJobUrlId?: string
    referralCode?: string
}

export type JobSeekerSignupRes = {
    userId: string | null
    createdNewUser: boolean
    requiresLogin: boolean
}

export type JobSeekerSubmissionSummary = {
    submissionId: string
    userId: string
    userName?: string
    userEmail?: string
    name: string
    email: string
    phone?: string
    linkedinUrl?: string
    acceptedTerms: boolean
    source?: string
    submittedAt: string
    userCreatedAt: string
    linkedPersonId?: string
    screeningJob?: {
        id: string
        jobTitle: string
        clientName: string | null
    }
}

export type GetJobSeekerSubmissionsRes = {
    submissions: JobSeekerSubmissionSummary[]
    total: number
}

export type GetJobSeekerSubmissionsParams = {
    page?: number
    pageSize?: number
}

class JobSeekerApi {
    private static instance: JobSeekerApi

    public constructor() {
        if (JobSeekerApi.instance) {
            return JobSeekerApi.instance
        }

        JobSeekerApi.instance = this
    }

    public async submitSignup(
        data: JobSeekerSignupReq,
    ): Promise<JobSeekerSignupRes> {
        return await http.post(
            '/jobseeker/signup',
            data,
            undefined,
            undefined,
            false,
        )
    }

    public async getSubmissions(
        params?: GetJobSeekerSubmissionsParams,
    ): Promise<GetJobSeekerSubmissionsRes> {
        const query = new URLSearchParams()
        if (params?.page) {
            query.set('page', params.page.toString())
        }
        if (params?.pageSize) {
            query.set('pageSize', params.pageSize.toString())
        }
        return await http.get('/jobseeker/submissions', query)
    }
}

const jobSeekerApi = new JobSeekerApi()
export default jobSeekerApi
